import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import { toAbsoluteUrl } from 'src/_metronic/helpers'

interface PasswordResetConfirmModalProps {
  show: boolean
  onConfirm: () => void
  onCancel: () => void
  loading: boolean
}

const PasswordResetConfirmModal: React.FC<PasswordResetConfirmModalProps> = ({
  show,
  onConfirm,
  onCancel,
  loading
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header className='border-0 pb-0'>
        <div className='w-100 text-center'>
         
          <Modal.Title className='d-block fs-5 fw-bold'>Reset/Forgot Password</Modal.Title>
        </div>
      </Modal.Header>

      <Modal.Body className='px-5 py-4'>
        <div className='w-100 text-center'>

         <img 
            src={toAbsoluteUrl('/media/logos/def-small.png')}
            alt='logo' 
            className='mb-3'
            style={{height: '60px', width: 'auto'}}
          />

          </div>
        <p className='mb-3 text-center'>
          You are requesting Reset/Forgot Password. Your existing password will be voided and you will receive password reset link in your registered email.
        </p>
        <p className='fw-bold text-center mb-4'>
          Are you sure you want to proceed Reset/Forgot Password?
        </p>
        <div className='d-flex gap-3 justify-content-center mt-4'>
          <Button 
            className='btn-primary'
            onClick={onConfirm}
            disabled={loading}
            style={{minWidth: '100px'}}
          >
            {loading ? 'Processing...' : 'Yes'}
          </Button>
          <Button 
            className='btn-outline-secondary' 
            onClick={onCancel}
            disabled={loading}
            style={{minWidth: '100px'}}
          >
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export {PasswordResetConfirmModal}
